export default __webpack_public_path__ + "static/media/session_expire.26626fe1.svg";